
import { Component, Vue } from 'vue-property-decorator'
import PasswordGuide from '@/components/templates/password/PasswordGuide.vue'

/**
 * パスワード再設定手続き送信完了ページ
 */
@Component({
  components: {
    PasswordGuide,
  },
})
export default class StudentPasswordReminderComplete extends Vue {}
